import { FeatureModal } from 'views/components';
import { configActions } from 'core/Config';
import { useTranslation } from 'react-i18next';
import {
    Accordion,
    Container,
    ExpandButton,
    FormGroup,
    IconButton,
    Input,
    Text
} from 'mol-ui';
import React, { useState } from 'react';
import {
    useCopyToClipboard,
    useDispatch,
    useInput,
    useSelector
} from 'hooks';

const ChatbotConfiguration = () => {

    const dispatch = useDispatch();
    const [copy, copyResult] = useCopyToClipboard();
    const [featureModal, setFeatureModal] = useState(false);
    const [featureInput, feature, setFeature] = useInput('');
    const [featureImportInput, featureImport] = useInput('');
    const [importInput, importData] = useInput('');
    const { t } = useTranslation();

    const {
        chatbotJSON,
        chatbotJSONLoading
    } = useSelector('config');

    const handleFeatureSelect = featureKey => {
        setFeature(featureKey);
        setFeatureModal(false);
    };

    const handleGenerate = () => {
        if (!feature) return;
        dispatch(configActions.getChatbotJSON(feature));
    };

    const handleUpload = () => {
        if (!importData || !featureImport) return;
        dispatch(configActions.updateChatbotFeature({
            content: JSON.parse(importData),
            feature: featureImport
        }));
    };

    return (
        <Container>
            <FeatureModal
                active={ !!featureModal }
                allowDelete={ false }
                onSelect={ handleFeatureSelect }
                onToggle={ () => setFeatureModal(false) }
            />
            <Accordion defaultOpened title={ t('Exportar') }>
                <Container alignItems="center" flexDirection="row" gap="20px">
                    <FormGroup label={ t('Función') }>
                        <Input { ...featureInput } margin="0px" onEnterPress={ handleGenerate } />
                    </FormGroup>
                    <ExpandButton
                        caption={ t('Generar') }
                        disabled={ !feature }
                        loading={ chatbotJSONLoading }
                        margin="20px 0px 0px 0px"
                        size={ 80 }
                        onClick={ handleGenerate }
                    />
                    <ExpandButton
                        circle
                        icon="open_in_new"
                        margin="20px 0px 0px 0px"
                        size={ 40 }
                        onClick={ () => setFeatureModal(true) }
                    />
                </Container>
                {
                    !!chatbotJSON &&
                    <Container margin="20px 0px 0px 0px">
                        <Text wordBreak="break-all">
                            { JSON.stringify(chatbotJSON) }
                        </Text>
                        <IconButton
                            icon={ copyResult ? 'done' : 'content_copy' }
                            margin="10px 0px 0px 0px"
                            size={ 14 }
                            onClick={ () => copy(JSON.stringify(chatbotJSON)) }
                        />
                    </Container>
                }
            </Accordion>
            <Accordion defaultOpened title={ t('Importar') }>
                <FormGroup label={ t('Función') }>
                    <Input { ...featureImportInput } margin="0px 0px 10px 0px" />
                </FormGroup>
                <Input { ...importInput } height="100px" type="area" />
                <ExpandButton
                    caption={ t('Cargar') }
                    disabled={ !importData }
                    loading={ chatbotJSONLoading }
                    size={ 80 }
                    onClick={ handleUpload }
                />
            </Accordion>
        </Container>
    );
};

export default ChatbotConfiguration;
